import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-32664de6")

_pushScopeId("data-v-32664de6")
const _hoisted_1 = { class: "graph-bar" }
const _hoisted_2 = { class: "graph-bar__header" }
const _hoisted_3 = { class: "graph-bar__header__grand-total" }
const _hoisted_4 = { class: "graph-bar__header__description" }
const _hoisted_5 = { class: "graph-bar__header__total" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "graph-bar__header__description" }, "bruto per maand", -1)
const _hoisted_7 = { class: "graph-bar__header__total-breakdown only-mobile" }
const _hoisted_8 = { class: "graph-bar__header__description" }
const _hoisted_9 = { class: "graph-bar__header__total" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "graph-bar__header__description" }, "bruto per maand", -1)
const _hoisted_11 = { class: "graph-bar__graph" }
const _hoisted_12 = { class: "graph-bar__label" }
const _hoisted_13 = { class: "graph-bar__description" }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, _toDisplayString(_ctx.totalOfMaxPercent) + "%", 1),
        _createVNode("div", _hoisted_5, _toDisplayString(_ctx.formattedTotalValue), 1),
        _hoisted_6
      ]),
      _createVNode("div", _hoisted_7, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.visibleRenderSegments, (segment) => {
          return (_openBlock(), _createBlock("div", {
            key: segment.type,
            class: segment.resultClass
          }, [
            _createVNode("div", _hoisted_8, _toDisplayString(segment.heightPercent), 1),
            _createVNode("div", _hoisted_9, _toDisplayString(segment.formattedValue.value), 1),
            _hoisted_10
          ], 2))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ]),
    _createVNode("div", _hoisted_11, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.renderSegments, (segment) => {
        return (_openBlock(), _createBlock("div", {
          key: segment.type,
          class: [segment.resultClass, "graph-bar__segment"],
          style: {
          '--height': segment.heightPercent,
        },
          onClick: $event => (_ctx.$emit('segment-click', segment))
        }, [
          _createVNode("div", _hoisted_12, [
            _createVNode("div", {
              class: "graph-bar__label__inner",
              innerHTML: segment.label
            }, null, 8, ["innerHTML"])
          ])
        ], 14, ["onClick"]))
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    _createVNode("div", _hoisted_13, _toDisplayString(_ctx.description.value || _ctx.description), 1)
  ]))
})